<template>
  <div>
    首頁 公告之類的
  </div>
</template>

<script>
  export default {
    name: 'index',
  };

</script>

<style lang="scss">

</style>
